import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Card from '../Card'

import css from './index.scss'


export default class CustomTable extends Component {
  constructor() {
    super()
    this.renderHeaders = this.renderHeaders.bind(this)
  }

  renderHeaders() {
    return this.props.headers.map((item, i) => (
      <TableHeaderColumn
        dataField={item.field}
        key={`col-${1}`}
        isKey={i === 0}
        dataFormat={item.componentToRender ? (cell, row, index) =>
          item.componentToRender(cell, row, index) : cell => cell}
        width={item.customWidth ? item.customWidth : null}
      >
        {item.label}
      </TableHeaderColumn>
    ))
  }

  render() {
    const options = {
      onRowClick: this.props.onRowClick,
      noDataText: this.props.noDataMessage || '',
      ...this.props.options,
      // onRowClick: (row, columnIndex) => {
      //   alert(`You click row id: ${row.id}, column index: ${columnIndex}`)
      // },
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: 8 }}>
        <Card style={{ width: '100%' }} >
          <BootstrapTable
            data={this.props.data}
            containerClass={css.tableContainer}
            trClassName={css.defaultTr}
            bodyContainerClass={css.bodyContainerClass}
            tableHeaderClass={css.headerContainerClass}
            bordered={false}
            hover={false}
            options={options}
            pagination={this.props.pagination}
          >
            {this.renderHeaders()}
          </BootstrapTable>

        </Card>
      </div>
    )
  }
}
